const standardContactFields = [
  'languageCode',
  'phoneNumber',
  'email',
]
const genders = [
  {
    id: 'male',
  },
  {
    id: 'female',
  },
  {
    id: 'other',
  },
]
const documentTypes = [
  {
    id: 'ID_CARD',
    allowedKey: 'allowedIdCardNationalities',
  },
  {
    id: 'PASSPORT',
    allowedKey: 'allowedPassportNationalities',
  },
]
const reservationTypes = {
  IN_VENUE: 'IN_VENUE',
  ROOM_SERVICE: 'ROOM_SERVICE',
}
const activityReservationColorsByStatus = {
  ACCEPTED: { background: 'green lighten-5', text: 'green darken-4', dot: 'green lighten-2' },
  PENDING: { background: 'amber lighten-5', text: 'amber darken-4', dot: 'amber lighten-2' },
  REJECTED: { background: 'red lighten-5', text: 'red darken-4', dot: 'red lighten-2' },
  ATTENDED: { background: 'teal lighten-5', text: 'teal darken-4', dot: 'teal lighten-2' },
  ABSENT: { background: 'grey lighten-3', text: 'grey darken-4', dot: 'grey lighten-2' },
  CANCELLED: { background: 'red lighten-5', text: 'red darken-4', dot: 'red lighten-2' },
  PENDING_MODIFICATION: { background: 'amber lighten-5', text: 'amber darken-4', dot: 'amber lighten-2' },
}
const activityReservationStatus = {
  ACCEPTED: 'ACCEPTED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  ATTENDED: 'ATTENDED',
  ABSENT: 'ABSENT',
  CANCELLED: 'CANCELLED',
  PENDING_MODIFICATION: 'PENDING_MODIFICATION',
}

const orderLineTypes = {
  SALE: 'SALE',
  TAX: 'TAX',
  DISCOUNT: 'DISCOUNT',
  GRATUITY: 'GRATUITY',
}

const orderLineItemEntities = {
  PRODUCT: 'PRODUCT',
  ACTIVITY: 'ACTIVITY',
  RESERVATION_METHOD: 'RESERVATION_METHOD',
  CATALOG_PRODUCT_MODIFIER_OPTION: 'CATALOG_PRODUCT_MODIFIER_OPTION',
  RESERVATION_METHOD_ATTENDEE_TYPE: 'RESERVATION_METHOD_ATTENDEE_TYPE',
}

const modificationRequestConfig = {
  pending: { key: 'pending', color: 'orange accent-2', icon: 'mdi-clock-outline' },
  success: { key: 'success', color: 'light-green lighten-1', icon: 'mdi-check-circle-outline' },
  error: { key: 'error', color: 'red lighten-1', icon: 'mdi-alert' },
}

const currencyTypes = {
  SERVICE: 'SERVICE',
  VIRTUAL: 'VIRTUAL',
  ACCESS: 'ACCESS',
  OBJECT: 'OBJECT',
  LEGAL: 'LEGAL',
}

const capacityControlModes = {
  RESERVATIONS: 'RESERVATIONS',
  ATTENDEES: 'ATTENDEES',
}

const localHostNames = ['127.0.0.1', 'localhost', '::1']

const attendeeTypeConfigurationTypes = {
  NOMINAL: 'NOMINAL',
  NUMERAL: 'NUMERAL',
}

export {
  standardContactFields,
  genders,
  documentTypes,
  reservationTypes,
  activityReservationColorsByStatus,
  activityReservationStatus,
  orderLineTypes,
  orderLineItemEntities,
  modificationRequestConfig,
  currencyTypes,
  capacityControlModes,
  localHostNames,
  attendeeTypeConfigurationTypes,
}
